import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';

import { FolderKinds, ItemStates } from '@site-mate/dashpivot-shared-library';

import { TmpI18NService } from 'app/i18n/tmp-i18n.service';
import { AbstractListPage } from 'app/lists/abstract-list-page/abstract-list-page.component';
import { ListFormat, ListsService } from 'app/lists/lists.service';
import { SegmentService } from 'app/segment/segment.service';
import { ConfirmService } from 'app/shared/service/confirm.service';
import { ErrorHandler } from 'app/shared/service/error-handler.service';
import { EventsService } from 'app/shared/service/events/events.service';
import { ToastrService } from 'app/shared/service/toastr.service';

@Component({
  selector: 'cc-list-project-page',
  templateUrl: '../abstract-list-page/abstract-list-page.component.html',
  styleUrls: ['../abstract-list-page/abstract-list-page.component.scss'],
})
export class ListProjectPageComponent extends AbstractListPage implements OnInit {
  public readonly parentType = 'projects';
  folderKind = FolderKinds.Project;

  constructor(
    activatedRoute: ActivatedRoute,
    changeDetectorRef: ChangeDetectorRef,
    confirmService: ConfirmService,
    errorHandler: ErrorHandler,
    listsService: ListsService,
    router: Router,
    segmentService: SegmentService,
    toastrService: ToastrService,
    eventsService: EventsService,
    i18nService: TmpI18NService,
  ) {
    super(
      activatedRoute,
      changeDetectorRef,
      confirmService,
      errorHandler,
      listsService,
      router,
      segmentService,
      toastrService,
      eventsService,
      i18nService,
    );
  }

  ngOnInit() {
    const { state } = this.activatedRoute.snapshot.data;

    this.activatedRoute.params
      .pipe(
        filter((params) => params.projectId),
        takeUntil(this.destroy$),
      )
      .subscribe(
        (params) => {
          this.state.isLoading = true;
          this.parentId = params.projectId;
          this.loadLists(state);
        },
        (error) => {
          this.errorHandler.handle(error);
          this.state.isLoading = false;
        },
      );
  }

  getLists(parentId: string, state: ItemStates) {
    return this.listsService.getMetaDataList(FolderKinds.Project, parentId, state, ListFormat.Thumbnail);
  }
}
